import React from "react";
import { createBrowserHistory } from "history";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "pages/LoginPage";
import { AbuseReportsPage } from "pages/abuseReports/AbuseReportsPage";
import { NewCourseSuggestionsPage } from "pages/courseSuggestions/NewCourseSuggestionsPage";
import { CourseSuggestionPage } from "pages/courseSuggestions/CourseSuggestionPage";
import { useQuery } from "@apollo/client";
import { GET_USER_HEADER } from "apollo-client/queries";
import { showErrorToast } from "toast-service";

const history = createBrowserHistory();

const RequireAuth = ({ children }) => {
  if (!localStorage.getItem("token")) return <Navigate to="/login" />;

  const { data: userData, loading: isLoadingUserData } =
    useQuery(GET_USER_HEADER);

  if (isLoadingUserData) return <p>LOADING</p>;

  if (userData?.user?.isAdmin === false) {
    localStorage.removeItem("token");
    showErrorToast("You are not authorized to access this page", 10000);
    return <Navigate to="/login" />;
  }

  return children;
};

function MainRoutes() {
  return (
    <BrowserRouter history={history}>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route exact path="/login" element={<LandingPage />} />
        <Route
          exact
          path="/abuse-reports"
          element={
            <RequireAuth>
              <AbuseReportsPage />
            </RequireAuth>
          }
        />
        <Route
          exact
          path="/new-course-suggestions"
          element={
            <RequireAuth>
              <CourseSuggestionPage />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default MainRoutes;
